import React from 'react';
import uuid from 'uuid/v4';
import { defineMessages, injectIntl } from 'react-intl';
import Title from './title';
import money, { Money, format } from '../lib/money';
import { formatMessage } from '../lib/intl';

const i18n = defineMessages({
  title: {
    id: 'costComponents.title',
    defaultMessage: 'Details',
  },
  headerConcept: {
    id: 'costComponents.headers.concept',
    defaultMessage: 'Concept',
  },
  headerAmount: {
    id: 'costComponents.headers.amount',
    defaultMessage: 'Amount',
  },
  total: {
    id: 'costComponents.total',
    defaultMessage: 'Total',
  },
});

export const CostComponents = ({ costComponents, intl }) => {
  const amounts = costComponents.map(c => money(c.amount));
  const total = Money.sum(amounts);
  const _formatMessage = formatMessage(intl);

  return (
    <div className="cost-components">
      <Title text={_formatMessage(i18n.title)} divider />
      <table className="table">
        <thead>
          <tr>
            <th className="small-print">
              {_formatMessage(i18n.headerConcept)}
            </th>
            <th className="small-print">
              {_formatMessage(i18n.headerAmount)}
            </th>
          </tr>
        </thead>
        <tbody>
          {renderCostComponents(costComponents)}
          <tr className="divider">
            <td colSpan="2" className="text-right cool-grey">
              {_formatMessage(i18n.total)}
            </td>
            <td>{format(total)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const renderCostComponents = components => (
  components.map(component => (
    <tr key={`component${uuid()}`}>
      <td>{component.concept}</td>
      <td>{format(component.amount)}</td>
    </tr>
  ))
);

CostComponents.defaultProps = {
  costComponents: [],
};

export default injectIntl(CostComponents);



// WEBPACK FOOTER //
// ./src/desktop/components/cost-components.js